import { Outlet } from 'react-router';
import { WrapperWithSidebar } from './components/WrapperWithSidebar';

export function GameLayout() {
  return (
    <WrapperWithSidebar>
      <div className="w-full flex flex-col justify-start items-center">
        <Outlet />
      </div>
    </WrapperWithSidebar>
  );
}
